 
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"; 
import useMediaQuery from "@mui/material/useMediaQuery";
import Modal from "@mui/material/Modal"; 
import "./ReuseableComponent.css";
import GCTitleSticky from "./GCTitleSticky";
const GCWebReport = ({
  xfCloseWebReportModal,
  xWebReportUrlModal = "",
  xTitle = "Report",
  xWebReportModal = false,
}) => {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  return (
    <Modal
      open={xWebReportModal}
      onClose={xfCloseWebReportModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="model-WMSStockReport">
      <GCTitleSticky
        title={xTitle}
        onClose={xfCloseWebReportModal}
        />
        
        
        <Grid container spacing={0} columns={{ xs: 12, sm: 12, md: 12 }}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className="d-flex justify-content-center"
          >
            <div
              style={{
                width: "100%",
                height: "calc(100vh - 47px)",
                textAlign: "center",
              }}
            >
              <iframe
                src={xWebReportUrlModal}
                id="iframe-webReport"
                title="Iframe Example"
                style={{ width: "100%", height: "100%", border: "none" }}
              ></iframe>
            </div>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default GCWebReport;
